import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function CaseStudies() {
  return (
    <PageLayout
      title="Enterprise Case Studies"
      subtitle="Discover how high-velocity hospitality and software platforms scale with Paygent."
      badge="SUCCESS STORIES"
      imageSrc="/products/art_casestudies_1776905191433.png"
    >
      <div className="mt-16 space-y-12">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-[2.5rem] p-10 md:p-16 text-white shadow-xl">
          <div className="inline-block px-4 py-1.5 rounded-full bg-white/20 font-bold text-sm mb-6 backdrop-blur-sm">
            HOSPITALITY SCALE
          </div>
          <h2 className="text-4xl font-extrabold mb-6">MatchdayATL</h2>
          <p className="text-blue-100 text-lg mb-8 max-w-3xl leading-relaxed">
            When organizing high-volume watch parties for thousands of attendees, MatchdayATL required a ticketing and payout architecture that wouldn't crash under load. Using Tapn's event velocity model, they processed over 15,000 "Taps" in a single weekend with zero downtime and eliminated hardware rental friction.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-white/20">
            <div>
              <p className="text-blue-200 text-sm font-semibold mb-1 uppercase">Volume</p>
              <p className="text-3xl font-bold">15K+</p>
            </div>
            <div>
              <p className="text-blue-200 text-sm font-semibold mb-1 uppercase">Hardware Cost</p>
              <p className="text-3xl font-bold">$0</p>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
